import { EnglishStr } from "@/lib/EnglishStr";
import { setClickInsightEvents } from "@/lib/util";
import { RootState } from "@/store/dtm";
import style from "@/styles/pages/ConfirmApplication/ConfirmApplication.module.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function ApplicationDecline() {

  const referralProducts = useSelector((state: RootState) => state.referralProducts.products);
  const application = useSelector(
    (state: RootState) => state.application.application
  );
  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );

  useEffect(() => {
    setClickInsightEvents(referralProducts, "applicationFailure", "main", "new", "auto-declined", application.id, applicant);

  }, [])
  
  return (
    <main aria-labelledby="main-content">
      <div className="flex flex-col max-xs:px-3 sm:ml-80 max-md:items-center max-md:mt-20">
        <div className={style.rtHeading}>
          <h1>Thank you for applying for a Meridian account.</h1>
          <p className="sub-heading mt-5">
            We regret to tell you that Meridian is unable to fill the request
            for account opening at this time. If you have any questions about
            this decision, please call our Member Service team at{" "}
            <a href="tel" target="_blank">
              {" "}
              <span className="active underline">
                {EnglishStr.ContactCentrePhone}
              </span>
            </a>{" "}
            or{" "}
            <a href="https://www.meridiancu.ca" target="_blank">
              <span className="active underline">visit a Meridian branch</span>
            </a>{" "}
          </p>
        </div>
      </div>
    </main>
  );
}
